import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';

import {connect} from 'react-redux';

import ConversionMenuPanel from './ConversionMenuPanel';
import ConversionPanel from './ConversionPanel';

import * as ArchitectActions from '../../actions/architectActions';

import classes from './ConversionPage.module.css';

class ConversionPage extends Component {
    state = {
        formType: null
    };

    async componentDidMount() {
        const {fetchConversions, companyInfo} = this.props;

        if (companyInfo.companyId) {
            await fetchConversions(companyInfo.companyId);
        }
    }

    async componentDidUpdate(prevProps) {
        const {fetchConversions, companyInfo} = this.props;

        if (prevProps.companyInfo !== companyInfo) {
            await fetchConversions(companyInfo.companyId);

            this.setState({
                formType: null
            });
        }
    }

    handleAddConversion = () => {
        this.setState({
            formType: 'add'
        });
    };

    handleEditConversion = () => {
        this.setState({
            formType: 'edit'
        });
    };

    handleDeleteConversion = () => {
        this.setState({
            formType: null
        });
    };

    render() {
        return (
            <div className={classes.ConversionPage}>
                <div className={classes.menuPanel}>
                    <ConversionMenuPanel
                        onAddConversion={this.handleAddConversion}
                        onEditConversion={this.handleEditConversion}
                    />
                </div>
                <div className={classes.conversionPanel}>
                    <ConversionPanel
                        formType={this.state.formType}
                        onDeleteConversion={this.handleDeleteConversion}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        companyInfo: state.companyInfo,
        conversions: state.architect.conversions
    };
};

const mapDispatchToProps = {
    ...ArchitectActions
};

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(ConversionPage)
);
